import i18n from '@common/i18n.js';

export function getSatisfactionStepText(step) {
    const veryGood = i18n.t('SatisfactionUtil_veryGood');
    const good = i18n.t('SatisfactionUtil_good');
    const normal = i18n.t('SatisfactionUtil_normal');
    const bad = i18n.t('SatisfactionUtil_bad');
    const veryBad = i18n.t('SatisfactionUtil_veryBad');

    switch (step) {
        case 3:
            return [good, normal, bad];

        case 4:
            return [veryGood, good, bad, veryBad];

        case 5:
            return [veryGood, good, normal, bad, veryBad];
    }
}
